jQuery(document).ready(function($) {

    $('.shopify-section--shopTheLook .Grid__Cell .ProductItem__ImageWrapper').on('click', function() {
        const productID = $(this).attr('data-section-id');
        $('.ShopTheLookPopup').attr('aria-hidden', 'true');
        $('.ShopTheLookPopup[data-section-id="'+productID+'"]').attr('aria-hidden', 'false');
    });

    $('.ShopTheLookPopup__Close').on('click', function() {
        $(this).parent().attr('aria-hidden', 'true');
    });
  
});